import axios from 'axios';

import {
  WT_API_URL,
  AUTH_URL,
  OAUTH_API_URL,
  WT_API_URL_BASE,
} from 'config/api.routes';

import { createSecureInstance } from './createSecureInstance';
import { createAuthRefreshInstance } from './createAuthRefreshInstance';

export const wtPortfolioApi = createSecureInstance(`${WT_API_URL_BASE}/api/v1`);

export const wtPortfolioRealApi = createSecureInstance(
  `${WT_API_URL}/wt-portfolio-real`,
);

export const wtComplianceApi = createSecureInstance(
  `${WT_API_URL}/wt-compliance`,
);

export const wtCatalogsApi = createSecureInstance(
  `${WT_API_URL_BASE}/api/v1/catalog`,
);

export const authRefreshApi = createAuthRefreshInstance(AUTH_URL || '');

export const oauthApi = axios.create({
  baseURL: OAUTH_API_URL,
});

export const wtOperationsApi = createSecureInstance(
  `${WT_API_URL_BASE}/v1/wt-operations`,
);

export const wtUserApi = createSecureInstance(`${WT_API_URL_BASE}/v1/wt-user`);

export const wtClientApi = createSecureInstance(
  `${WT_API_URL_BASE}/v1/wt-client`,
);
